

// // export default FormPage;
// import React, { useEffect, useRef, useState } from "react";
// import { useParams } from "react-router-dom";
// import API from "../services/api";

// import * as pdfjsLib from "pdfjs-dist/build/pdf";
// import worker from "pdfjs-dist/build/pdf.worker.min.js";

// import Cropper from "cropperjs";
// import "cropperjs/dist/cropper.min.css";

// import "./form.css";

// pdfjsLib.GlobalWorkerOptions.workerSrc = worker;

// function FormPage() {
//   const { token } = useParams();

//   const [signature, setSignature] = useState(null);
//   const [extraPdf, setExtraPdf] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [agree, setAgree] = useState(false);


//   const [aadhaar, setAadhaar] = useState([]);
//   const [pan, setPan] = useState(null);
//   const [bank, setBank] = useState(null);
//   const [dra, setDra] = useState(null);
//   const [education, setEducation] = useState([]);
//   const [cv, setCv] = useState(null);



//   const renderingRef = useRef(false);
//   const pdfContainerRef = useRef(null);

//   const imageRef = useRef(null);
//   const cropper = useRef(null);
//   const finalBlob = useRef(null);

//   // ================= LOAD PDF =================
//   useEffect(() => {
//     if (!token) return;

//     fetch(`https://vgmconsult.net/api/form/get-by-token/${token}`)
//       .then(res => res.json())
//       .then(data => {
//         const filePath = data.file?.replace(/^\/+/, ""); // ✅ FIX
//         const fileUrl = `https://vgmconsult.net/${filePath}`;
//         renderPDF(fileUrl);
//       })
//       .catch(() => setMessage("❌ Failed to load document"));
//   }, [token]);

//   // ================= RENDER PDF =================
//   const renderPDF = async (url) => {
//     if (renderingRef.current) return;
//     renderingRef.current = true;

//     try {
//       const container = pdfContainerRef.current;
//       container.innerHTML = "";

//       const pdf = await pdfjsLib.getDocument(url).promise;

//       for (let i = 1; i <= pdf.numPages; i++) {
//         const page = await pdf.getPage(i);

//         const viewport = page.getViewport({ scale: 1.2 });

//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");

//         canvas.width = viewport.width;
//         canvas.height = viewport.height;

//         await page.render({
//           canvasContext: ctx,
//           viewport,
//         }).promise;

//         container.appendChild(canvas);
//       }
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ PDF load failed");
//     }

//     renderingRef.current = false;
//   };

//   // ================= FILE CHANGE =================
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setSignature(file);
//     setMessage("");

//     const url = URL.createObjectURL(file);

//     imageRef.current.src = url;
//     imageRef.current.style.display = "block";

//     if (cropper.current) {
//       cropper.current.destroy();
//     }

//     cropper.current = new Cropper(imageRef.current, {
//       aspectRatio: 3,
//       viewMode: 1,
//       background: false,
//     });
//   };

//   const handlePdfChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (file.type !== "application/pdf") {
//       setMessage("❌ Only PDF allowed");
//       return;
//     }

//     setExtraPdf(file);
//     setMessage("📎 PDF attached");
//   };

//   // ================= CROP =================
//   const cropImage = () => {
//     if (!cropper.current) return;

//     const canvas = cropper.current.getCroppedCanvas({
//       width: 500,
//       height: 180,
//       fillColor: "transparent",
//     });

//     const ctx = canvas.getContext("2d");
//     const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//     const data = imgData.data;



//     for (let i = 0; i < data.length; i += 4) {
//       const r = data[i];
//       const g = data[i + 1];
//       const b = data[i + 2];

//       const brightness = (r + g + b) / 3;
//       // Slightly relaxed the blue detection to capture more edge pixels
//       const isBlueInk = (b > r + 3 && b > g + 3);

//       if (isBlueInk && brightness < 235) {
//         // DEEPER COLOR: Reduced Red/Green and set Blue to a rich navy
//         data[i] = 2;     // Deepest Red component
//         data[i + 1] = 12;  // Deepest Green component
//         data[i + 2] = 70;  // Deep Blue

//         // INCREASED OPACITY: Changed exponent and added higher floor
//         let pressure = 255 - brightness;
//         // Lowering the exponent (0.5) makes lighter areas much darker/denser
//         pressure = Math.pow(pressure / 255, 0.5) * 255;

//         // Minimum alpha set higher (80) to prevent "faded" looking ink
//         data[i + 3] = Math.min(255, pressure + 80);
//       } else {
//         data[i + 3] = 0;
//       }
//     }
//     ctx.putImageData(imgData, 0, 0);

//     canvas.toBlob((blob) => {
//       finalBlob.current = blob;
//     }, "image/png");

//     imageRef.current.src = canvas.toDataURL("image/png");

//     setMessage("✅ Signature Ready");
//   };

//   // ================= UPLOAD =================
//   const handleUpload = async () => {
//   if (!finalBlob.current) {
//     setMessage("⚠ Crop signature first");
//     return;
//   }

//   if (!agree) {
//     setMessage("⚠ Please accept document");
//     return;
//   }

//   try {
//     setLoading(true);
//     setMessage("");

//     const formData = new FormData();

//     // ✅ Signature
//     formData.append("file", finalBlob.current, "signature.png");

//     // ✅ Optional extra PDF
//     if (extraPdf) {
//       formData.append("extra_pdf", extraPdf);
//     }

//     // ================= NEW DOCUMENTS =================

//     // ✅ Aadhaar (multiple)
//     aadhaar.forEach((file) => {
//       formData.append("aadhaar", file);
//     });

//     // ✅ Education (multiple)
//     education.forEach((file) => {
//       formData.append("education", file);
//     });

//     // ✅ Single files
//     if (pan) formData.append("pan", pan);
//     if (bank) formData.append("bank", bank);
//     if (dra) formData.append("dra", dra);
//     if (cv) formData.append("cv", cv);

//     // ================= API CALL =================

//     const res = await API.post(
//       `/form/upload-signature/${token}`,
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );

//     setMessage("✅ Signed successfully");


//       // ✅ FIX URL (remove double slash)
//       const cleanPath = res.data.signed_pdf?.replace(/^\/+/, "");
//       const fileUrl = `https://vgmconsult.net/api/${cleanPath}`;

//       // ✅ DOWNLOAD
//       const link = document.createElement("a");
//       link.href = fileUrl;
//       link.download = "Signed_Document.pdf";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // ✅ OPEN IN NEW TAB
//       window.open(fileUrl, "_blank");

//       setTimeout(() => {
//         window.location.href = "/thank-you";
//       }, 3000);

//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="form-container">

//       <div className="form-header">
//         <h1>📄 Commission Agent Agreement</h1>
//         <p>Please read and sign the document</p>
//       </div>

//       {message.includes("Signed") ? (
//         <div className="success-box">
//           <h2>✅ Document Signed Successfully</h2>
//         </div>
//       ) : (
//         <>
//           <div className="pdf-container" ref={pdfContainerRef}></div>

//           <div className="upload-section">

//             <h2>✍ Upload Signature</h2>

//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleFileChange}
//               disabled={loading}
//             />

//             {signature && <p>📸 {signature.name}</p>}

//             <img ref={imageRef} className="preview-img" alt="preview" />
//             <h3>📄 Aadhaar (Front & Back)</h3>
//             <input type="file" multiple onChange={(e) => setAadhaar([...e.target.files])} />

//             <h3>🪪 PAN Card</h3>
//             <input type="file" onChange={(e) => setPan(e.target.files[0])} />

//             <h3>🏦 Bank Proof</h3>
//             <input type="file" onChange={(e) => setBank(e.target.files[0])} />

//             <h3>📜 DRA Certificate</h3>
//             <input type="file" onChange={(e) => setDra(e.target.files[0])} />

//             <h3>🎓 Educational Certificates</h3>
//             <input type="file" multiple onChange={(e) => setEducation([...e.target.files])} />

//             <h3>📄 CV</h3>
//             <input type="file" accept="application/pdf" onChange={(e) => setCv(e.target.files[0])} />


//             <button onClick={cropImage} disabled={loading}>
//               ✂ Crop Signature
//             </button>

//             <h3>📎 Upload Additional PDF</h3>
//             <input
//               type="file"
//               accept="application/pdf"
//               onChange={handlePdfChange}
//               disabled={loading}
//             />

//             {extraPdf && <p>📎 {extraPdf.name}</p>}


//             <div className="checkbox">
//               <input
//                 type="checkbox"
//                 checked={agree}
//                 onChange={(e) => setAgree(e.target.checked)}
//                 disabled={loading}
//               />
//               <label>I agree to this document</label>
//             </div>

//             <button onClick={handleUpload} disabled={loading}>
//               {loading ? "Submitting..." : "Submit Signature"}
//             </button>

//             {message && <p className="message">{message}</p>}
//           </div>
//         </>
//       )}

//       {loading && (
//         <div className="loading-overlay">
//           <div className="loader"></div>
//         </div>
//       )}

//     </div>
//   );
// }

// export default FormPage;





// import React, { useEffect, useRef, useState } from "react";
// import { useParams } from "react-router-dom";
// import API from "../services/api";

// import * as pdfjsLib from "pdfjs-dist/build/pdf";
// import worker from "pdfjs-dist/build/pdf.worker.min.js";

// import Cropper from "cropperjs";
// import "cropperjs/dist/cropper.min.css";

// import "./form.css";

// pdfjsLib.GlobalWorkerOptions.workerSrc = worker;

// function FormPage() {
//   const { token } = useParams();

//   const [signature, setSignature] = useState(null);
//   const [extraPdf, setExtraPdf] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [agree, setAgree] = useState(false);



//   const [aadhaar, setAadhaar] = useState([]);
//   const [pan, setPan] = useState(null);
//   const [bank, setBank] = useState(null);
//   const [dra, setDra] = useState(null);
//   const [education, setEducation] = useState([]);
//   const [cv, setCv] = useState(null);


//   const renderingRef = useRef(false);
//   const pdfContainerRef = useRef(null);

//   const imageRef = useRef(null);
//   const cropper = useRef(null);
//   const finalBlob = useRef(null);

//   // ================= LOAD PDF =================
//   // useEffect(() => {
//   //   if (!token) return;

//   //   fetch(`https://vgmconsult.net/api/form/get-by-token/${token}`)
//   //     .then(res => res.json())
//   //     .then(data => {
//   //       const filePath = data.file?.replace(/^\/+/, ""); // ✅ FIX
//   //       const fileUrl = `https://vgmconsult.net/${filePath}`;
//   //       renderPDF(fileUrl);
//   //     })
//   //     .catch(() => setMessage("❌ Failed to load document"));
//   // }, [token]);

//   useEffect(() => {
//     if (!token) return;

//     let isMounted = true;

//     fetch(`https://vgmconsult.net/api/form/get-by-token/${token}`)
//       .then(res => res.json())
//       .then(data => {
//         if (!isMounted) return;

//         const filePath = data.file?.replace(/^\/+/, "");
//         const fileUrl = `https://vgmconsult.net/${filePath}`;

//         renderPDF(fileUrl);
//       })
//       .catch(() => setMessage("❌ Failed to load document"));

//     return () => {
//       isMounted = false;
//     };
//   }, [token]);

//   // ================= RENDER PDF =================
//   const renderPDF = async (url) => {
//     if (renderingRef.current) return;
//     renderingRef.current = true;

//     try {
//       const container = pdfContainerRef.current;
//       // container.innerHTML = "";
//       while (container.firstChild) {
//         container.removeChild(container.firstChild);
//       }

//       const pdf = await pdfjsLib.getDocument(url).promise;

//       for (let i = 1; i <= pdf.numPages; i++) {
//         const page = await pdf.getPage(i);

//         const viewport = page.getViewport({ scale: 1.2 });

//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");

//         canvas.width = viewport.width;
//         canvas.height = viewport.height;

//         await page.render({
//           canvasContext: ctx,
//           viewport,
//         }).promise;

//         container.appendChild(canvas);
//       }
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ PDF load failed");
//     }

//     renderingRef.current = false;
//   };

//   // ================= FILE CHANGE =================
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setSignature(file);
//     setMessage("");

//     const url = URL.createObjectURL(file);

//     imageRef.current.src = url;
//     imageRef.current.style.display = "block";

//     if (cropper.current) {
//       cropper.current.destroy();
//     }

//     cropper.current = new Cropper(imageRef.current, {
//       aspectRatio: 3,
//       viewMode: 1,
//       background: false,
//     });
//   };

//   const handlePdfChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (file.type !== "application/pdf") {
//       setMessage("❌ Only PDF allowed");
//       return;
//     }

//     setExtraPdf(file);
//     setMessage("📎 PDF attached");
//   };

//   // ================= CROP =================
  // const cropImage = () => {
  //   if (!cropper.current) return;

  //   const canvas = cropper.current.getCroppedCanvas({
  //     width: 500,
  //     height: 180,
  //     fillColor: "transparent",
  //   });

  //   const ctx = canvas.getContext("2d");
  //   const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  //   const data = imgData.data;


  //   for (let i = 0; i < data.length; i += 4) {
  //     const r = data[i];
  //     const g = data[i + 1];
  //     const b = data[i + 2];

  //     const brightness = (r + g + b) / 3;
  //     // Slightly relaxed the blue detection to capture more edge pixels
  //     const isBlueInk = b > r + 3 && b > g + 3;

  //     if (isBlueInk && brightness < 235) {
  //       // DEEPER COLOR: Reduced Red/Green and set Blue to a rich navy
  //       data[i] = 2;
  //       data[i + 1] = 12;
  //       data[i + 2] = 70;  // Deep Blue

  //       // INCREASED OPACITY: Changed exponent and added higher floor
  //       let pressure = 255 - brightness;
  //       // Lowering the exponent (0.5) makes lighter areas much darker/denser
  //       // pressure = Math.pow(pressure / 255, 1.3) * 280;
  //       pressure = pressure;

  //       // Minimum alpha set higher (80) to prevent "faded" looking ink
  //       data[i + 3] = Math.min(255, pressure + 40);
  //     } else {
  //       data[i + 3] = 0;
  //     }
  //   }

  //   ctx.putImageData(imgData, 0, 0);

  //   canvas.toBlob((blob) => {
  //     finalBlob.current = blob;
  //   }, "image/png");

  //   imageRef.current.src = canvas.toDataURL("image/png");

  //   setMessage("✅ Signature Ready");
  // };

//   // ================= UPLOAD =================
//   const handleUpload = async () => {
//     if (!finalBlob.current) {
//       setMessage("⚠ Crop signature first");
//       return;
//     }

//     if (!agree) {
//       setMessage("⚠ Please accept document");
//       return;
//     }

//     try {
//       setLoading(true);
//       setMessage("");

//       const formData = new FormData();

//       // ✅ Signature
//       formData.append("file", finalBlob.current, "signature.png");

//       // ✅ Optional extra PDF
//       if (extraPdf) {
//         formData.append("extra_pdf", extraPdf);
//       }

//       // ================= NEW DOCUMENTS =================

//       // ✅ Aadhaar (multiple)
//       aadhaar.forEach((file) => {
//         formData.append("aadhaar", file);
//       });

//       // ✅ Education (multiple)
//       education.forEach((file) => {
//         formData.append("education", file);
//       });

//       // ✅ Single files
//       if (pan) formData.append("pan", pan);
//       if (bank) formData.append("bank", bank);
//       if (dra) formData.append("dra", dra);
//       if (cv) formData.append("cv", cv);

//       // ================= API CALL =================

//       const res = await API.post(
//         `/form/upload-signature/${token}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       setMessage("✅ Signed successfully");

//       // ✅ FIX URL
//       const cleanPath = res.data.signed_pdf?.replace(/^\/+/, "");
//       const fileUrl = `https://vgmconsult.net/api/${cleanPath}`;

//       // ✅ DOWNLOAD
//       const link = document.createElement("a");
//       link.href = fileUrl;
//       link.download = "Final_Document.pdf";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // ✅ OPEN
//       window.open(fileUrl, "_blank");

//       setTimeout(() => {
//         window.location.href = "/thank-you";
//       }, 3000);

//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <div className="form-container">

//       <div className="form-header">
//         <h1>📄 Commission Agent Agreement</h1>
//         <p>Please read and sign the document</p>
//       </div>

//       {message.includes("Signed") ? (
//         <div className="success-box">
//           <h2>✅ Document Signed Successfully</h2>
//         </div>
//       ) : (
//         <>
//           <div className="pdf-container" ref={pdfContainerRef}></div>

//           <div className="upload-section">

//             <h2>✍ Upload Signature</h2>

//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleFileChange}
//               disabled={loading}
//             />

//             {signature && <p>📸 {signature.name}</p>}

//             <img ref={imageRef} className="preview-img" alt="preview" />

//             <h3>📄 Aadhaar (Front & Back)</h3>
//             <input type="file" multiple onChange={(e) => setAadhaar([...e.target.files])} />

//             <h3>🪪 PAN Card</h3>
//             <input type="file" onChange={(e) => setPan(e.target.files[0])} />

//             <h3>🏦 Bank Proof</h3>
//             <input type="file" onChange={(e) => setBank(e.target.files[0])} />

//             <h3>📜 DRA Certificate</h3>
//             <input type="file" onChange={(e) => setDra(e.target.files[0])} />

//             <h3>🎓 Educational Certificates</h3>
//             <input type="file" multiple onChange={(e) => setEducation([...e.target.files])} />

//             <h3>📄 CV</h3>
//             <input type="file" accept="application/pdf" onChange={(e) => setCv(e.target.files[0])} />

//             <button onClick={cropImage} disabled={loading}>
//               ✂ Crop Signature
//             </button>

//             <h3>📎 Upload Additional PDF</h3>
//             <input
//               type="file"
//               accept="application/pdf"
//               onChange={handlePdfChange}
//               disabled={loading}
//             />

//             {extraPdf && <p>📎 {extraPdf.name}</p>}


//             <div className="checkbox">
//               <input
//                 type="checkbox"
//                 checked={agree}
//                 onChange={(e) => setAgree(e.target.checked)}
//                 disabled={loading}
//               />
//               <label>I agree to this document</label>
//             </div>

//             <button onClick={handleUpload} disabled={loading}>
//               {loading ? "Submitting..." : "Submit Signature"}
//             </button>

//             {message && <p className="message">{message}</p>}
//           </div>
//         </>
//       )}

//       {loading && (
//         <div className="loading-overlay">
//           <div className="loader"></div>
//         </div>
//       )}

//     </div>
//   );
// }

// export default FormPage;




import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../services/api";

import * as pdfjsLib from "pdfjs-dist/build/pdf";
import worker from "pdfjs-dist/build/pdf.worker.min.js";

import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";

import "./form.css";

pdfjsLib.GlobalWorkerOptions.workerSrc = worker;

function FormPage() {
  const { token } = useParams();

  const [signature, setSignature] = useState(null);
  const [extraPdf, setExtraPdf] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [agree, setAgree] = useState(false);

  const [aadhaar, setAadhaar] = useState([]);
  const [pan, setPan] = useState(null);
  const [bank, setBank] = useState(null);
  const [dra, setDra] = useState(null);
  const [education, setEducation] = useState([]);
  const [cv, setCv] = useState(null);

  const renderingRef = useRef(false);
  const pdfContainerRef = useRef(null);

  const imageRef = useRef(null);
  const cropper = useRef(null);
  const finalBlob = useRef(null);

  // ================= LOAD PDF =================
  useEffect(() => {
    if (!token) return;

    fetch(`https://vgmconsult.net/api/form/get-by-token/${token}`)
      .then(res => res.json())
      .then(data => {
        const filePath = data.file?.replace(/^\/+/, ""); 
        const fileUrl = `https://vgmconsult.net/${filePath}`;
        renderPDF(fileUrl);
      })
      .catch(() => setMessage("❌ Failed to load document"));
  }, [token]);

  // ================= RENDER PDF =================
  const renderPDF = async (url) => {
    if (renderingRef.current) return;
    renderingRef.current = true;

    try {
      const container = pdfContainerRef.current;
      container.innerHTML = "";

      const pdf = await pdfjsLib.getDocument(url).promise;

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 1.2 });
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
          canvasContext: ctx,
          viewport,
        }).promise;

        container.appendChild(canvas);
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ PDF load failed");
    }

    renderingRef.current = false;
  };

  // ================= FILE CHANGE =================
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSignature(file);
    setMessage("");

    const url = URL.createObjectURL(file);
    imageRef.current.src = url;
    imageRef.current.style.display = "block";

    if (cropper.current) {
      cropper.current.destroy();
    }

    cropper.current = new Cropper(imageRef.current, {
      aspectRatio: 3,
      viewMode: 1,
      dragMode: 'move', // Allows moving/scrolling page easier
      background: false,
      autoCropArea: 1,
      responsive: true,
      checkOrientation: false,
    });
  };

  const handlePdfChange = (e) => {
    const file = e.target.files[0];
    if (!file || file.type !== "application/pdf") {
      setMessage("❌ Only PDF allowed");
      return;
    }
    setExtraPdf(file);
    setMessage("📎 PDF attached");
  };

  // ================= CROP =================
   const cropImage = () => {
    if (!cropper.current) return;

    const canvas = cropper.current.getCroppedCanvas({
      width: 500,
      height: 180,
      fillColor: "transparent",
    });

    const ctx = canvas.getContext("2d");
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imgData.data;


    for (let i = 0; i < data.length; i += 4) {
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];

      const brightness = (r + g + b) / 3;
      // Slightly relaxed the blue detection to capture more edge pixels
      const isBlueInk = b > r + 3 && b > g + 3;

      if (isBlueInk && brightness < 235) {
        // DEEPER COLOR: Reduced Red/Green and set Blue to a rich navy
        data[i] = 2;
        data[i + 1] = 12;
        data[i + 2] = 70;  // Deep Blue

        // INCREASED OPACITY: Changed exponent and added higher floor
        let pressure = 255 - brightness;
        // Lowering the exponent (0.5) makes lighter areas much darker/denser
        // pressure = Math.pow(pressure / 255, 1.3) * 280;
        pressure = pressure;

        // Minimum alpha set higher (80) to prevent "faded" looking ink
        data[i + 3] = Math.min(255, pressure + 40);
      } else {
        data[i + 3] = 0;
      }
    }

    ctx.putImageData(imgData, 0, 0);

    canvas.toBlob((blob) => {
      finalBlob.current = blob;
    }, "image/png");

    imageRef.current.src = canvas.toDataURL("image/png");

    setMessage("✅ Signature Ready");
  };


  // ================= UPLOAD =================
  const handleUpload = async () => {
    if (!finalBlob.current) { setMessage("⚠ Crop signature first"); return; }
    if (!agree) { setMessage("⚠ Please accept document"); return; }

    try {
      setLoading(true);
      setMessage("");
      const formData = new FormData();
      formData.append("file", finalBlob.current, "signature.png");
      if (extraPdf) formData.append("extra_pdf", extraPdf);
      
      aadhaar.forEach((file) => formData.append("aadhaar", file));
      education.forEach((file) => formData.append("education", file));
      if (pan) formData.append("pan", pan);
      if (bank) formData.append("bank", bank);
      if (dra) formData.append("dra", dra);
      if (cv) formData.append("cv", cv);

      const res = await API.post(`/form/upload-signature/${token}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      setMessage("✅ Signed successfully");
      const cleanPath = res.data.signed_pdf?.replace(/^\/+/, "");
      const fileUrl =  `https://vgmconsult.net/api/${cleanPath}`;
      
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "Final_Document.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.open(fileUrl, "_blank");
      setTimeout(() => { window.location.href = "/thank-you"; }, 3000);
    } catch (err) {
      console.error(err);
      setMessage("❌ Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <h1>📄 Commission Agent Agreement</h1>
        <p>Please read and sign the document</p>
      </div>

      {message.includes("Signed") ? (
        <div className="success-box">
          <h2>✅ Document Signed Successfully</h2>
        </div>
      ) : (
        <>
          <div className="pdf-container" ref={pdfContainerRef}></div>

          <div className="upload-section">
            <h2>✍ Upload Signature</h2>
            <input type="file" accept="image/*" onChange={handleFileChange} disabled={loading} />
            {signature && <p>📸 {signature.name}</p>}

            {/* FIXED WRAPPER FOR SCROLLING */}
            <div className="cropper-wrapper">
              <img ref={imageRef} className="preview-img" alt="preview" />
            </div>

            <button className="crop-btn" onClick={cropImage} disabled={loading}>✂ Crop Signature</button>

            <div className="docs-grid">
              <div className="doc-field">
                <h3>📄 Aadhaar (Front & Back)</h3>
                <input type="file" multiple onChange={(e) => setAadhaar([...e.target.files])} />
              </div>

              <div className="doc-field">
                <h3>🪪 PAN Card</h3>
                <input type="file" onChange={(e) => setPan(e.target.files[0])} />
              </div>

              <div className="doc-field">
                <h3>🏦 Bank Proof</h3>
                <input type="file" onChange={(e) => setBank(e.target.files[0])} />
              </div>

              <div className="doc-field">
                <h3>📜 DRA Certificate</h3>
                <input type="file" onChange={(e) => setDra(e.target.files[0])} />
              </div>

              <div className="doc-field">
                <h3>🎓 Educational Certificates</h3>
                <input type="file" multiple onChange={(e) => setEducation([...e.target.files])} />
              </div>

              <div className="doc-field">
                <h3>📄 CV</h3>
                <input type="file" accept="application/pdf" onChange={(e) => setCv(e.target.files[0])} />
              </div>
              
              <div className="doc-field">
                <h3>📎 Upload Additional PDF</h3>
                <input type="file" accept="application/pdf" onChange={handlePdfChange} disabled={loading} />
                {extraPdf && <p>📎 {extraPdf.name}</p>}
              </div>
            </div>

            <div className="checkbox-area">
              <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} disabled={loading} />
              <label>I agree to this document</label>
            </div>

            <button className="submit-btn" onClick={handleUpload} disabled={loading}>
              {loading ? "Submitting..." : "Submit Signature & Documents"}
            </button>

            {message && <p className="message">{message}</p>}
          </div>
        </>
      )}

      {loading && (
        <div className="loading-overlay">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
}

export default FormPage;